import React from 'react';
import { BRAND, navItems } from '../data/content';
import { SocialLinks } from './SocialLinks';
import { SmartImage } from './SmartImage';
import type { LegalDoc } from './LegalModal';
type FooterProps = {
  onOpenLegal: (doc: LegalDoc) => void;
};
export function Footer({
  onOpenLegal
}: FooterProps) {
  const year = new Date().getFullYear();
  return <footer className="relative w-full overflow-hidden bg-ink" id="contacto" data-id="element-118" data-mp="36nd5lhmw8a35">
      <div className="hairline" aria-hidden="true" data-id="element-119" data-mp="3ufjwi19unov6" />

      <div className="relative" data-id="element-120" data-mp="38h456i9zcjd">
        <SmartImage src={BRAND.footerUrl} alt="NORBERTH Presenta" width={2138} height={712} wrapperClassName="aspect-[3/1] w-full" className="absolute inset-0 h-full w-full object-cover" data-id="element-121" data-mp="37fth3568s26" />
        <div aria-hidden="true" className="pointer-events-none absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-ink to-transparent" data-id="element-122" data-mp="29zgl41oc4umn" />
      </div>

      <div className="relative mx-auto max-w-7xl px-5 pb-10 pt-10 lg:px-10" data-id="element-123" data-mp="2evx98vvjb8zq">
        <div className="flex flex-col items-start justify-between gap-10 border-b border-white/[0.07] pb-10 lg:flex-row lg:items-center" data-id="element-124" data-mp="3l9sjf6xt4wpj">
          <div data-id="element-125" data-mp="3v7gexz38m88r">
            <p className="font-display text-2xl uppercase tracking-wide text-white" data-id="element-126" data-mp="3v89fgibls1ig">
              ¿Conversamos?
            </p>
            <p className="mt-2 max-w-sm text-sm leading-relaxed text-ash" data-id="element-127" data-mp="3q7txtekag7uo">
              Solicita una reunión o escribe directamente por WhatsApp.
            </p>
            <div className="mt-4 flex flex-wrap items-center gap-x-6 gap-y-2" data-id="element-128" data-mp="34gvzesy8n6j">
              <a href={BRAND.whatsappUrl} target="_blank" rel="noopener noreferrer" className="font-sans text-sm tracking-wide text-white transition-colors duration-300 hover:text-gold" data-id="element-129" data-mp="hsttig7oqe35">
                {BRAND.whatsappNumber}
              </a>
              <a href={BRAND.instagramUrl} target="_blank" rel="noopener noreferrer" className="font-sans text-sm tracking-wide text-ash transition-colors duration-300 hover:text-gold" data-id="element-130" data-mp="msg56l7v7m9u">
                {BRAND.instagramHandle}
              </a>
            </div>
          </div>

          <nav aria-label="Navegación del pie de página" data-id="element-131" data-mp="13r7of4scwwqd">
            <ul className="flex flex-wrap gap-x-8 gap-y-3" data-id="element-132" data-mp="18l2dknqqe3wu">
              {navItems.map(item => <li key={item.href} data-id="element-133" data-mp="1ckkr2yg83cpn">
                  <a href={item.href} className="font-sans text-[13px] uppercase tracking-[0.14em] text-ash transition-colors duration-300 hover:text-gold" data-id="element-134" data-mp="1cnp2ogw0paqc">
                    {item.label}
                  </a>
                </li>)}
            </ul>
          </nav>

          <SocialLinks data-id="element-135" data-mp="3oboppmyxfvkq" />
        </div>

        <div className="mt-8 flex flex-col items-start justify-between gap-5 sm:flex-row sm:items-center" data-id="element-136" data-mp="3ocq1jtnrom3i">
          <p className="font-sans text-xs tracking-wide text-ash/70" data-id="element-137" data-mp="3tai199unlci9">
            © {year} {BRAND.name}. Todos los derechos reservados.
          </p>
          <ul className="flex items-center gap-6" data-id="element-138" data-mp="25nvkwylcdq8k">
            <li data-id="element-139" data-mp="25man903qdr6h">
              <button type="button" onClick={() => onOpenLegal('privacy')} className="font-sans text-xs uppercase tracking-[0.16em] text-ash transition-colors duration-300 hover:text-gold" data-id="element-140" data-mp="21mtg828nolz7">
                Privacy
              </button>
            </li>
            <li aria-hidden="true" className="h-3 w-px bg-steel" data-id="element-141" data-mp="2pcntum0sueki" />
            <li data-id="element-142" data-mp="2pa9xm9uduwbd">
              <button type="button" onClick={() => onOpenLegal('terms')} className="font-sans text-xs uppercase tracking-[0.16em] text-ash transition-colors duration-300 hover:text-gold" data-id="element-143" data-mp="2kdb4numggver">
                Terms
              </button>
            </li>
          </ul>
        </div>
      </div>
    </footer>;
}